import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Close as CloseIcon, DirectionsBoat as CruiseIcon, OpenInNew as ExternalLinkIcon } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

class CruisePortalModal extends Component {
  render() {
    const {
      isOpen, closePricingModal, classes,
    } = this.props;

    if (!isOpen) return null;

    return (
      <div
        className={classes.overlay}
        onClick={closePricingModal}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Escape') closePricingModal();
        }}
      >
        <div
          className={classes.modal}
          onClick={(e) => e.stopPropagation()}
          role="button"
          tabIndex={0}
        >
          {/* Header */}
          <div className={classes.header}>
            <div className={classes.headerTitle}>
              <CruiseIcon className={classes.headerIcon} />
              <span>Cruise Bookings</span>
            </div>
            <button
              type="button"
              className={classes.closeButton}
              onClick={closePricingModal}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Content */}
          <div className={classes.content}>
            {/* Main Description */}
            <div className={classes.mainDescription}>
              Flynote has partnered with leading cruise providers to bring the world&apos;s cruise inventory to you at negotiated rates.
            </div>

            {/* Bullet Points */}
            <ul className={classes.bulletList}>
              <li>We recommend to start your research for bookable inventory here.</li>
              <li>Note that prices listed are cost price, please add markup on top while quoting customers</li>
              <li>Once a cruise is selected, tell the AI agent to add it to your itinerary</li>
              <li>Please note, the prices are dynamic and may change over time.</li>
            </ul>

            {/* Portal Buttons */}
            <div className={classes.portalButtons}>
              <a
                href="https://www.deckpro.in/"
                target="_blank"
                rel="noopener noreferrer"
                className={classes.portalButton}
              >
                <ExternalLinkIcon className={classes.buttonIcon} />
                Go to DeckPro Portal
              </a>
            </div>

            {/* Login Instructions */}
            <div className={classes.loginSection}>
              <div className={classes.loginTitle}>
                Please login to the cruise portal to get started:
              </div>
              <div>
                <span><b>Website:</b></span>
                <span className={classes.websiteLinks}>
                  <a href="https://www.deckpro.in/" target="_blank" rel="noopener noreferrer" className={classes.websiteLink}>
                    https://www.deckpro.in/
                  </a>
                </span>
              </div>
              <div>
                <span><b>Mobile:</b></span>
                <span className={classes.websiteLinks}>
                  tech@flynote.in 
                </span>
              </div>
              <div>
                <span><b>Password:</b></span>
                <span className={classes.websiteLinks}>
                  arktravelsystem
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    width: 800,
    maxWidth: '90vw',
    maxHeight: '90vh',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    position: 'relative',
    display: 'flex',
    fontSize: 14,
    flexDirection: 'column',
    fontFamily: 'Sofia-pro, sans-serif',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  },
  header: {
    height: 72,
    borderBottom: '1px solid #E5E5E5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 40px',
    flexShrink: 0,
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    fontSize: 24,
    fontWeight: 600,
    color: '#1A1A1A',
  },
  headerIcon: {
    color: theme.colors.primary,
    fontSize: 32,
    marginRight: 10,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#666666',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    },
  },
  content: {
    flex: 1,
    padding: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    overflowY: 'auto',
  },
  mainDescription: {
    fontSize: 16,
    color: '#333333',
    lineHeight: 1.6,
    marginBottom: 8,
  },
  bulletList: {
    margin: 0,
    paddingLeft: 24,
    listStyleType: 'disc',
    '& li': {
      fontSize: 15,
      color: '#333333',
      marginBottom: 12,
      lineHeight: 1.5,
    },
  },
  portalButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 8,
  },
  portalButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    padding: '14px 28px',
    backgroundColor: theme.colors.primary,
    border: 'none',
    borderRadius: 24,
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 600,
    height: 36,
    width: 250,
    textDecoration: 'none',
    cursor: 'pointer',
    fontFamily: 'Sofia-pro, sans-serif',
    transition: 'all 0.2s',
    '&:hover': {
      backgroundColor: theme.colors.primary,
      color: theme.colors.white,
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0, 144, 181, 0.3)',
    },
  },
  buttonIcon: {
    fontSize: 20,
    marginRight: 5,
  },
  loginSection: {
    paddingTop: 20,
    color: theme.colors.textDark,
  },
  loginTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 5,
  },
  websiteLabel: {
    fontSize: 15,
    fontWeight: 600,
    color: '#333333',
  },
  websiteLinks: { 
    marginLeft: 5,
  },
  websiteLink: {
    fontSize: 15,
    color: '#0090B5',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

CruisePortalModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closePricingModal: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CruisePortalModal);
